module.exports = __webpack_public_path__ + "img/icon-talkbubble.28a28ff1.svg";